export default __webpack_public_path__ + "static/media/asmt-step5.1cced44d.gif";